let base_url = ""
let ws_url = ""

if (import.meta.env.DEV) {
  console.log("当前环境：开发环境")
  base_url = "https://api.lora.yunludeng.com"
  ws_url = "/api/ws"
} else {
  console.log("当前环境：生产环境")
  base_url = "https://api.lora.yunludeng.com"
  ws_url = `ws://${location.hostname}:23400`
}
export {
  base_url,
  ws_url
}
